<template>
  <div class="hamburger">
    <div class="bar" />
    <div class="bar" />
    <div class="bar" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.hamburger {
  box-sizing: content-box;
  width: 35px;
  padding: 15px;
  margin: -15px;
}

.bar {
  height: 3px;
  background-color: black;
  transition: all 0.5s;

  &:nth-child(1) {
    width: 100%;
    margin-bottom: 10px;
    .active & {
      transform: translateY(calc(13px)) rotate(45deg);
    }
  }

  &:nth-child(2) {
    width: 100%;
    transform: translateX(0);
    margin-bottom: 10px;
    .active & {
      opacity: 0;
      transform: translateX(20px) !important;
    }
  }

  &:nth-child(3) {
    width: 100%;
    .active & {
      transform: translateY(calc(-13px)) rotate(-45deg);
    }
  }

}
</style>
